import { Serializable } from '@/models/core/serializable';
import { GEnum } from '@/constants/enum.defination';

export class AuthInfo implements Serializable<AuthInfo> {
  userID: number;
  authToken: string;
  email: string;
  name: string;
  companyID: number;
  companyName: string;
  role: GEnum.Role; // 権限
  licenseExpired: boolean;
  authCodeRequire: boolean;
  authCodeFail: boolean;
  deserialize(input: any): AuthInfo {
    this.userID = input.userID;
    this.authToken = input.authToken;
    this.email = input.email;
    this.name = input.name;
    this.companyID = input.companyID;
    this.companyName = input.companyName;
    this.role = input.role;
    this.licenseExpired = input.licenseExpired;
    this.authCodeRequire = input.authCodeRequire;
    this.authCodeFail = input.authCodeFail;
    return this;
  }
}
